module.exports = __webpack_public_path__ + "img/9@2x.e483b504.png";